import React from "react";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import { actions as AuthActions, selectors as AuthSelectors } from "@containers/Auth/store";
import { actions as sharedActions } from "@shared/store";
import { OVERLAY_TYPES, USER_PERMISSION } from "@shared/constants";
import { actions as AccountActions } from "@containers/Account/store";
import { AccessControl } from "@shared/components/AccessControl";
import { Button, Icon } from "@shared/components";
import { User } from "@shared/models";
import { getUserDetails } from "@shared/store/selectors";
import { getActiveAccount } from "@containers/Account/store/selectors";
import { checkIfAdmin } from "@shared/utils/ACL";

import { store } from "../../../../../index";

interface UserActionsProps {
  client: User;
}

export const UserActions = ({ client }: UserActionsProps) => {
  const location = useLocation();
  const isImpersonated = useSelector(AuthSelectors.impersonated());
  const contact = store.getState().account.selectedAccount;

  const activeUser = useSelector(getUserDetails());
  const activeAccount = useSelector(getActiveAccount());
  const isActiveUserPrimary = activeAccount?.user_id === activeUser?.id && !checkIfAdmin(activeUser!);

  const showEditUserOverlay = () => {
    store.dispatch(
      sharedActions.showOverlay({
        type: OVERLAY_TYPES.CREATE_EDIT_CLIENT,
        closeOnOverlayClick: true,
        props: {
          client,
          callback: () => {
            store.dispatch(AccountActions.getAccount.request({ id: Number(contact?.id) }));
          },
        },
      }),
    );
  };

  const handleImpersonation = () => {
    store.dispatch(
      AuthActions.impersonation.request({
        user_id: client.id,
        account_id: contact?.id,
        returnLocation: `${location.pathname}${location.search}`,
      }),
    );
  };

  return (
    <div className="actions">
      {!isImpersonated && !isActiveUserPrimary && (
        <AccessControl permission={USER_PERMISSION.IMPERSONATE}>
          <Button onClick={handleImpersonation} buttonStyle="view">
            <Icon type="user-shadow-blue" />
            Impersonate
          </Button>
        </AccessControl>
      )}
      <AccessControl allow={isActiveUserPrimary} permission={USER_PERMISSION.UPDATE_USER}>
        <Button onClick={showEditUserOverlay} buttonStyle="edit" disabled={isActiveUserPrimary && checkIfAdmin(client)}>
          <Icon type="edit" />
          Edit
        </Button>
      </AccessControl>
    </div>
  );
};
